import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import GetUp from './views/GetUp.vue'
import DailySumup from './views/DailySumup.vue'
import ImageView from './views/ImageView.vue'
import Heahth from "./views/Heahth";
// import NetTree from "./views/NetTree.vue.bak";
import QRCodeLogin from "./views/QrLogin";
import ScanCode from "./views/ScanCodeVant";
import WorkplaceView from "./views/WorkplaceView";


Vue.use(Router)

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // , {
    //   path: '/microService/wechat/nettree',
    //   //  path: '/getup',
    //   name: 'netTree',
    //   component: NetTree,
    //   meta: {  title: '关系图',requiresAuth: false }
    // }

    {
      path: '/',
      //  path: '/getup',
      name: 'home',
      component: Home,
      meta: {  title: '每日一句'}
    }
  ]
})

export default router;
/*
router.beforeEach((to, from, next) => {  //to 需要跳转到哪    from 从哪跳转过来的    next跳转
  let user_code = sessionStorage.getItem("user_code")
  if(to.matched.some(res => res.meta.requiresAuth)){  //遍历出需要鉴权的页面
    if(user_code!=null&&user_code!=''){  //
      next();
    }else{
      next({
        path:'/',
        query: {redirect: to.fullPath}
      })
    }
  }else{
    next();
  }
*/
